import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center max-w-full" }
const _hoisted_2 = { class: "flex justifiy-between max-w-full gap-2" }
const _hoisted_3 = ["onPaste", "onKeyup", "onUpdate:modelValue"]

import {
		ref,
		nextTick
	} from "vue"

	//eslint-disable-next-line
	
	// name the component
	const __default__ = { name: 'TwConfirmationCode' }

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
		modelValue: {
			type: String,
			default: null
		}
	},
  emits: [
		'update:modelValue'
	],
  setup(__props, { emit: __emit }) {


	const props = __props

	const emit = __emit

	const code = ref([null,null,null,null,null,null])

	function handleLeft(e: any) {
		const previousInput = e.target.previousElementSibling
		if (!previousInput) return
		previousInput.focus()
		return
	}

	function handleRight(e: any) {
		const nextInput = e.target.nextElementSibling
		if (!nextInput) return
		nextInput.focus()
		return
	}

	async function handleBackspace(e: any,i: number) {
		if(i === 0) return
		const input = e.target
		const sibling = input.previousElementSibling
		
		if (input.value) {
			input.value = ''
			code.value[i] = null
		}
		if(sibling.value) {
			sibling.focus()
			sibling.value = ''
			code.value[i-1] = null
		}
		emit('update:modelValue', code.value.join(''))
		await nextTick()

		return
	}

	async function handlePaste(e: any,i: number) {
		if(i > 0) return
		e.preventDefault()
		const paste = e.clipboardData.getData('text')
		for(let i = 0; i < code.value.length ; i++) {
			code.value[i] = paste.charAt(i) || ''
		}

		emit('update:modelValue', code.value.join(''))
		await nextTick()
	}

	// update modeled value
	const onInput = async ({ target }: any) => {
		emit('update:modelValue', code.value.join(''))
		await nextTick()

		const input = target
		const nextInput = input?.nextElementSibling
		if (nextInput && input.value) {
			nextInput.focus()
			if (nextInput.value) {
				nextInput.select()
			}
		}

		return
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(code.value, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("input", {
          key: index,
          type: "tel",
          maxlength: "1",
          pattern: "[0-9]",
          onInput: onInput,
          onPaste: (e) => {handlePaste(e, index)},
          onKeyup: [
            _withKeys((e) => {handleBackspace(e, index)}, ["backspace"]),
            _cache[0] || (_cache[0] = _withKeys((e) => {handleLeft(e)}, ["left"])),
            _cache[1] || (_cache[1] = _withKeys((e) => {handleRight(e)}, ["right"]))
          ],
          "onUpdate:modelValue": ($event: any) => ((code.value[index]) = $event),
          class: "focus:ring-dbBlue focus:border-dbBlue border-gray-300 flex-none w-[52px] h-[52px] text-center text-xl min-w-0"
        }, null, 40, _hoisted_3)), [
          [_vModelText, code.value[index]]
        ])
      }), 128))
    ])
  ]))
}
}

})